import Tracker from "./tracker.js";

class ValueTracker extends Tracker {
    constructor(userdata) {
        super();

        this._oldExists = false;
        this._oldValue = undefined;
        this._newExists = false;
        this._newValue = undefined;

        const prop = Object.freeze(Object.defineProperties({}, {
            oldExists: { get: () => this._oldExists, enumerable: true },
            oldValue: { get: () => this._oldValue, enumerable: true },
            newExists: { get: () => this._newExists, enumerable: true },
            newValue: { get: () => this._newValue, enumerable: true },
        }));

        this._trackData = Object.freeze({ prop, userdata });
    }

    protected_startUpdate() {
        return this._trackData;
    }

    protected_finishUpdate() {
        this._oldExists = this._newExists;
        this._oldValue = this._newValue;
    }

    _propertyChange(newExists, newValue) {
        const changed = this._oldExists !== newExists || this._oldValue !== newValue;

        this._newExists = newExists;
        this._newValue = newValue;

        this.protected_needsUpdate(changed);
    }

    setValue(newValue) {
        this._propertyChange(true, newValue);
    }

    deleteValue() {
        this._propertyChange(false, undefined);
    }
}

export default ValueTracker;
